import { Cookies } from 'react-cookie';

const cookies = new Cookies();

export const setCookies = (name, value, options = {}) => {
  try {
    cookies.set(name, value, options);
    return true;
  } catch (error) {
    console.error('setCookies error:', error);
    return null;
  }
};

export const getCookies = (name) => {
  try {
    return cookies.get(name);
  } catch (error) {
    console.error('getCookies error:', error);
    return null;
  }
};

export const clearAllCookies = () => {
  try {
    const allCookies = cookies.getAll();
    for (const cookie in allCookies) {
      cookies.remove(cookie, { path: '/' }); 
    }
  } catch (error) {
    console.error('clear cookies error:', error);
  }
};